export default __webpack_public_path__ + "img/bell-icon.8353c30c.svg";